import { createContext, useContext } from 'react';
import { StepsType } from './consts';

export type ContextProps = {
    email: string;
    setEmail: (email: string) => void;
    step: StepsType;
    nextStep: (step: StepsType) => void;
};

export const context = createContext<ContextProps>({
    email: '',
    setEmail: () => {},
    step: 'home',
    nextStep: () => {}
});

export const useFormData = () => useContext(context);
